import React from "react";
import { Grid, makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
    root: {
        fontSize: "1.1rem",
        borderRadius: 0,
        border: "solid 1px",

    }
}));

function PopCrudScreenActionItemLayout ( props ) {

    const classes = useStyle();

    const { children, ...others } = props;


        return (

            <Grid item>
                {
                    React.Children.map(children, ( child => 
                        React.cloneElement(child, { className: classes.root, ...others}) ) )
                }
            </Grid>


        );

}

export default PopCrudScreenActionItemLayout;

